import apiSlice from "./apiSlice";
const claimsPackagesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllClaims: builder.query({
      query: (req) => ({
        url: `claims`,
        params: req,
      }),
      keepUnusedDataFor: 1,
    }),
    getClaimsPackages: builder.query({
      query: ({ projectId, type }) => {
        const params = new URLSearchParams();
        if (projectId) params.append("projectId", projectId);
        if (type) params.append("type", type);
        return `WBS?${params.toString()}`;
      },
    }),
  }),
});

export const {
  useGetClaimsPackagesQuery,
  useLazyGetClaimsPackagesQuery,
  useGetAllClaimsQuery,
} = claimsPackagesSlice;
